import { Col, Form, Row } from 'antd';
import { FormComponentProps } from "antd/lib/form";
import TextArea from 'antd/lib/input/TextArea';
import React, { FormEvent } from 'react';

const FormItem = Form.Item;

export interface IEndAgreementFormProps extends FormComponentProps {
    onChange: (e: FormEvent<HTMLFormElement>) => void;
}

class EndAgreementForm extends React.Component<IEndAgreementFormProps>{
    public render() {
        const { onChange } = this.props;
        const { getFieldDecorator } = this.props.form;
        return (
            <Form
                layout="vertical"
                onChange={onChange}
            >
                <Row>
                    <Col>
                        <FormItem label='Cancellation Notes'>
                        {getFieldDecorator('notes', {
                            rules: [{
                                required: true,
                                message: 'Please input your notes!',
                            }],
                        })(<TextArea 
                            autosize={{ minRows: 5 }}
                            placeholder="Enter your notes..."
                        />)}
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        );
    }
}

export default Form.create<IEndAgreementFormProps>()(EndAgreementForm);
